/* :global(.handsontable) raises specificity above HT18's `.handsontable .htDimmed`
   (read-only cells), which also uses !important for background/color. */
:global(.handsontable) td.read-only-col {
    background-color: #f0f0f0 !important;
    color: black !important;
}

.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

:global(.handsontable) td.truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.column-header {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    gap: 4px;
}

.column-header-label {
    min-width: 0;
    max-width: 100px;
    flex: 1 1 auto;
}

.column-header-remove {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
}

:global(.handsontable) td.no-wrap {
    /* max-width: 100px !important; */
    overflow-wrap: break-word !important;
    white-space: pre-line !important;
}

:global(.handsontable) td.study-col {
    text-align: center !important;
    vertical-align: middle !important;
}

/* Type colors apply to cells (td) and column header labels (div.boolean, etc).
   The td selector is required so HT18 `.handsontable .htDimmed` does not win on cells. */
.boolean,
:global(.handsontable) td.boolean {
    color: green !important;
    text-align: center !important;
}

.string,
:global(.handsontable) td.string {
    color: orange !important;
    text-align: center !important;
}

.number,
:global(.handsontable) td.number {
    color: blue !important;
    text-align: center !important;
}

.null,
:global(.handsontable) td.null {
    color: gray !important;
    text-align: center !important;
}

.remove-column-icon {
    color: #db2222;
    cursor: pointer;
}

.remove-column-icon:hover {
    color: #b05f5f;
}
